const namespace = 'error';

// eslint-disable-next-line import/prefer-default-export
export const SET_STATUS_CODE = `${namespace}/SET_STATUS_CODE`;
